import React from 'react'
import { Box, Modal } from '@mui/material'
import { ModalContent } from '../../../common/components'
import { t } from 'i18next'
import { type SelectionProduct, type ProjectDto, type SystemInfoDto } from '../../../common/services'
import PpeModal from './modalPpe'
import KeyTranslation from '../../../common/KeyTranslation.json'
interface PpeModalProps {
  open: boolean
  onClose: () => void
  project?: ProjectDto
  systemData?: SystemInfoDto
  systemDatarefetch?: any
  product?: SelectionProduct[] | null
}

export default function ContainerPpeModal ({ open, onClose, project, systemData, systemDatarefetch, product }: PpeModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t(KeyTranslation.System_BaseComponents)}>
          {
            <PpeModal
              open={open}
              onClose={onClose}
              title={t(KeyTranslation.Common_Choose_PPE)}
              project={project}
              systemData={systemData}
              systemDatarefetch={systemDatarefetch}
              product={product}
            />
          }
        </ModalContent>
      </Box>
    </Modal>
  )
}
